var _style, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 32,
    width: 32,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,2c-0.2,0-0.4,0.1-0.5,0.2L9.9,3.5L8.3,3.2C7.8,3.1,7.5,3.4,7.4,3.8L7.1,5.6L5.4,6.4C5,6.6,4.9,7,5.1,7.4L5.9,9 l-0.8,1.6c-0.2,0.4,0,0.8,0.3,1l1.7,0.8l0.3,1.8c0.1,0.4,0.5,0.7,0.9,0.6l1.9-0.3l1.4,1.3c0.3,0.3,0.8,0.3,1.1,0l1.4-1.3l1.9,0.3 c0.4,0.1,0.8-0.2,0.9-0.6l0.3-1.8l1.7-0.8c0.4-0.2,0.5-0.6,0.3-1L18.1,9l0.8-1.6c0.2-0.4,0.1-0.8-0.3-1l-1.7-0.8l-0.3-1.8 c-0.1-0.4-0.5-0.7-0.9-0.6l-1.9,0.3l-1.4-1.3C12.3,2,12,2,11.8,2z M6.1,13.1L3,19.3l3.6-0.5L8.4,22l2.6-5.3l-0.2-0.2l-1-0.9 l-1.4,0.2c-0.9,0.1-1.8-0.5-2-1.4L6.1,13.1L6.1,13.1z M17.9,13.1l-0.3,1.3c-0.2,0.8-0.9,1.4-1.7,1.4h-0.2l-1.4-0.2l-1,0.9l-0.2,0.2 l2.6,5.3l1.8-3.1l3.6,0.5L17.9,13.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.cb4470e003e20f71300c11d546a39d92.svg";
export { ForwardRef as ReactComponent };